import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {translate} from 'views/module';

import CaregiverPaymentSyncCsvData from './data/CaregiverPaymentSyncCsvData';
import WidgetHeader from '../utils/WidgetHeader';
import SmallSkeleton from '../utils/skeleton/SmallSkeleton';

const CaregiverPaymentSyncCsv = (props) => {
  const {
    editMode,
    removeWidget,
    statusProgressWrap,
  } = props;

  return (
    <>
      <WidgetHeader
        title={translate('dashboardWidgets.CaregiverPaymentSyncCsv.Title')}
        editMode={editMode}
        removeWidget={removeWidget}
      />
      <Box sx={{height: '400px', overflowY: 'auto', scrollbarWidth: 'thin', py: 1, pr: 1, mr: -1}}>
        {
          editMode ?
          <SmallSkeleton />:
          <CaregiverPaymentSyncCsvData
            statusProgressWrap={statusProgressWrap}
          />
        }
      </Box>
    </>
  );
};

CaregiverPaymentSyncCsv.propTypes = {
  editMode: PropTypes.bool.isRequired,
  removeWidget: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func,
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(CaregiverPaymentSyncCsv);
